import { GetWorkingType, HEADERS } from '../pages/api';
import axios from 'axios';
import { getOrgId } from '../pages/api';


export default async function getWorkingDayTypeServices() {
    const data = {
        "org_id": getOrgId()
    }
    try {
        const response = await axios.post(GetWorkingType, data, {
            headers: HEADERS
        });
        // Do something with the response data
        // $&


        return response.data

    } catch (error) {
        // Handle errors here
        console.error('Error fetching data:', error);
        throw new Error('Failed to fetch data');
    }
}